import React from 'react';

interface PaginationProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;
    return (
        <div className="flex items-center justify-center gap-3 px-[22px] py-[14px] border-t border-mapper-border-3">
            <button
                onClick={() => onPageChange(page - 1)}
                disabled={page <= 1}
                className="px-3 py-[6px] rounded-lg border border-mapper-border-2 text-[13px] font-semibold text-mapper-body-text disabled:opacity-40"
            >
                Previous
            </button>
            <span className="text-[13px] text-mapper-muted">Page {page} of {totalPages}</span>
            <button
                onClick={() => onPageChange(page + 1)}
                disabled={page >= totalPages}
                className="px-3 py-[6px] rounded-lg border border-mapper-border-2 text-[13px] font-semibold text-mapper-body-text disabled:opacity-40"
            >
                Next
            </button>
        </div>
    );
};
